<template>
  <div class="d-flex flex-column" style="background-color: #F9F9F9;">
    <div data-app :class="`d-flex flex-column ${isWide ? 'mx-30 my-20' : isMobile ? 'm-5' : 'mx-10 my-5'}`">
      <div :class="`d-flex ${isWide ? 'mx-auto w-75 justify-content-between vertical-center' : 'flex-column'}`">
        <div :class="`d-flex flex-column ${isWide ? 'mr-2' : ''}`">
          <span :class="`font-bold ${isWide ? 'font-30' : isMobile ? 'font-20' : 'font-25'}`">{{ $t('wallet') }}</span>
          <span :class="`mt-2 alpha-07 ${isWide ? 'font-20' : isMobile ? 'font-12' : 'font-15'}`" v-if="eventInfo">{{ eventInfo.name }}</span>
        </div>
      </div>
      <div :class="`box-white d-flex justify-content-between vertical-center ${isWide ? 'mt-10 mx-auto w-75 center px-10 py-5' : isMobile ? 'mt-5 p-5' : 'mt-7 px-10 py-5'}`" v-if="tagList.length > 0">
        <span :class="isMobile ? 'font-12' : 'font-20'">{{ $t('tag') }}</span>
        <div class="w-100 ml-3 input-normal d-flex">
          <span :class="`${isMobile? 'font-12' : 'font-15'}`">{{ selectedTag }}</span>
        </div>
        <v-btn class="ml-3 button-small" icon @click="keywordTag = ''; visibleSelectTagDialog = true;">
          <i :class="`${isMobile ? 'font-12' : 'font-15'} fa fa-search color-white`" />
        </v-btn>
      </div>
      <div :class="`box-white ${isWide ? 'mt-10 mx-auto w-75 center px-10 py-5' : isMobile ? 'mt-5 p-5' : 'mt-7 px-10 py-5'}`" v-if="items">
        <b-tabs :fill="isMobile" :class="isMobile ? 'mx-1' : 'mx-10'" v-model="tabIndex">
          <b-tab :title="item.name" v-for="(item, index) in items" :key="(item, index)">
            <template #title>
              <span :class="`${isMobile ? 'font-12' : 'font-15'} ${index == tabIndex ? 'font-bold color-pink' : ''}`">{{ item.name }}</span>
            </template>
            <div class="mt-10 d-flex flex-column">
              <div :class="`mt-10 ${isWide ? 'mx-20' : 'mx-5'} d-flex justify-content-between`">
                <span :class="isMobile ? 'font-12' : 'font-15'">{{ $t('total_charged_amount') }}</span>
                <span :class="`font-bold ${isMobile ? 'font-12' : 'font-15'}`">{{ getPriceFormat(item.chargedAmount) }}</span>
              </div>
              <div :class="`mt-5 ${isWide ? 'mx-20' : 'mx-5'} d-flex justify-content-between`" v-if="item.key === ''">
                <span :class="isMobile ? 'font-12' : 'font-15'">{{ $t('total_spent_amount') }}</span>
                <span :class="`font-bold ${isMobile ? 'font-12' : 'font-15'}`">{{ getPriceFormat(item.spendAmount) }}</span>
              </div>
              <div :class="`mt-5 ${isWide ? 'mx-20' : 'mx-5'} d-flex justify-content-between`">
                <span :class="isMobile ? 'font-12' : 'font-15'">{{ $t('number_of_charged_users') }}</span>
                <span :class="`font-bold ${isMobile ? 'font-12' : 'font-15'}`">{{ getDecimalFormat(item.userCount) }}</span>
              </div>
              <div :class="`mt-5 ${isWide ? 'mx-20' : 'mx-5'} d-flex justify-content-between`">
                <span :class="isMobile ? 'font-12' : 'font-15'">{{ $t('total_withdrawn_amount') }}</span>
                <span :class="`font-bold ${isMobile ? 'font-12' : 'font-15'}`">{{ getPriceFormat(item.withdrawnAmount) }}</span>
              </div>
              <div :class="`mt-5 ${isWide ? 'mx-20' : 'mx-5'} d-flex justify-content-between`">
                <span :class="isMobile ? 'font-12' : 'font-15'">{{ $t('handling_fee') }}</span>
                <span :class="`font-bold ${isMobile ? 'font-12' : 'font-15'}`">{{ getPriceFormat(item.handlingFee) }}</span>
              </div>
              <div :class="`mt-5 ${isWide ? 'mx-20' : 'mx-5'} d-flex justify-content-between`" v-if="item.key === ''">
                <span :class="isMobile ? 'font-12' : 'font-15'">{{ $t('total_remain_balance') }}</span>
                <span :class="`font-bold ${isMobile ? 'font-12' : 'font-15'}`">{{ getPriceFormat(item.chargedAmount - item.withdrawnAmount - item.spendAmount) }}</span>
              </div>
              <div :class="`mt-5 ${isWide ? 'mx-20' : 'mx-5'} d-flex justify-content-end`">
                <v-btn icon @click="generateInvoice(item.key)">
                  <img :src="assets.download" :height="isMobile ? 20 : 25" />
                </v-btn>
              </div>
              <hr v-if="item.historyList.length > 0" />
              <table class="w-100" v-if="item.historyList.length > 0">
                <thead>
                  <tr>
                    <th style="width: 17%;" :class="`font-bold ${isWide ? 'p-5 font-15' : 'p-2 font-12'}`">{{ $t('username') }}</th>
                    <th style="width: 16%;" :class="`font-bold ${isWide ? 'p-5 font-15' : 'p-2 font-12'}`">{{ $t('recharge_report') }}</th>
                    <th style="width: 15%;" :class="`font-bold ${isWide ? 'p-5 font-15' : 'p-2 font-12'}`">{{ $t('amount') }}</th>
                    <th style="width: 15%;" :class="`font-bold ${isWide ? 'p-5 font-15' : 'p-2 font-12'}`">{{ $t('handling_fee') }}</th>
                    <th style="width: 20%;" :class="`font-bold ${isWide ? 'p-5 font-15' : 'p-2 font-12'}`">{{ $t('date') }}</th>
                    <th style="width: 17%;" :class="`font-bold ${isWide ? 'p-5 font-15' : 'p-2 font-12'}`" v-if="item.key === ''">{{ $t('employee_name') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(historyInfo, index) in item.historyList" :key="(historyInfo, index)">
                    <td :class="isWide ? 'p-5 font-15' : 'p-2 font-12'">{{ historyInfo.userName }}</td>
                    <td :class="isWide ? 'p-5 font-15' : 'p-2 font-12'">{{ $t(historyInfo.type === TYPE_CHARGE ? 'charged' : 'withdrawn') }}</td>
                    <td :class="`font-bold ${isWide ? 'p-5 font-15' : 'p-2 font-12'} ${historyInfo.type === TYPE_CHARGE ? 'color-green' : 'color-red'}`">{{ getPriceFormat(historyInfo.amount) }}</td>
                    <td :class="isWide ? 'p-5 font-15' : 'p-2 font-12'">{{ getPriceFormat(historyInfo.handlingFee) }}</td>
                    <td :class="isWide ? 'p-5 font-15' : 'p-2 font-12'">{{ getDateStringFromTimestamp(historyInfo.createdAt) }}</td>
                    <td :class="isWide ? 'p-5 font-15' : 'p-2 font-12'" v-if="item.key === ''">{{ historyInfo.employeeName || myInfo.userName }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <div class="my-30 py-40 center" v-else>
        <b-spinner type="grow"></b-spinner>
        <p class="mt-5">{{ $t('alert_please_wait') }}</p>
      </div>
      <v-dialog v-model="visibleSelectTagDialog" :width="isWide ? '800px' : ''">
        <v-card style="min-height: 500px;">
          <v-card-title class="bg-pink d-flex justify-content-between">
            <span :class="`font-bold color-white ${isMobile ? 'font-15' : 'font-18'}`">{{ $t('tag') }}</span>
            <v-btn class="m-1" icon small @click="closeSelectTagDialog('')">
              <i class="flaticon-cancel font-bold font-25 color-white"></i>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div class="m-5 d-flex flex-column">
              <div class="mb-5 input-with-icon d-flex justify-content-between vertical-center">
                <i :class="`${isMobile ? 'font-15' : 'font-20'} fa fa-search color-icon`" />
                <input :class="`w-100 ${isMobile ? 'px-2' : 'px-5'}`" :placeholder="$t('search')" v-model="keywordTag" />
              </div>
              <div class="pointer d-flex flex-column" v-for="(tag, index) in getFilteredTagList()" :key="(tag, index)" @click="closeSelectTagDialog(tag)">
                <span :class="`my-3 tag-${tag === selectedTag ? 'selected' : 'normal'} font-bold ${isMobile ? 'font-12' : 'font-15'}`">{{ tag }}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1900"
        :pdf-quality="2"
        :manual-pagination="true"
        :html-to-pdf-options="htmlToPdfOptions"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="100%"
        @progress="onProgress"
        ref="html2Pdf">
        <div slot="pdf-content" class="d-flex flex-column" v-if="invoiceInfo && eventInfo">
          <div class="d-flex justify-content-end mb-5">
            <img :src="assets.logo" :height="30" />
          </div>
          <div class="mt-5 d-flex justify-content-between">
            <span class="font-12">{{ $t('event_name') }}</span>
            <span class="font-bold font-12">{{ eventInfo.name }}</span>
          </div>
          <div class="mt-2 d-flex justify-content-between" v-if="selectedTag">
            <span class="font-12">{{ $t('tag') }}</span>
            <span class="font-bold font-12">{{ selectedTag }}</span>
          </div>
          <span class="mt-10 font-bold font-15">{{ invoiceInfo.name }}</span>
          <div class="mt-5 d-flex justify-content-between">
            <span class="font-12">{{ $t('total_charged_amount') }}</span>
            <span class="font-bold font-15">{{ getPriceFormat(invoiceInfo.chargedAmount) }}</span>
          </div>
          <div class="mt-2 d-flex justify-content-between" v-if="invoiceInfo.key === ''">
            <span class="font-12">{{ $t('total_spent_amount') }}</span>
            <span class="font-bold font-15">{{ getPriceFormat(invoiceInfo.spendAmount) }}</span>
          </div>
          <div class="mt-2 d-flex justify-content-between">
            <span class="font-12">{{ $t('number_of_charged_users') }}</span>
            <span class="font-bold font-15">{{ getDecimalFormat(invoiceInfo.userCount) }}</span>
          </div>
          <div class="mt-2 d-flex justify-content-between">
            <span class="font-12">{{ $t('total_withdrawn_amount') }}</span>
            <span class="font-bold font-15">{{ getPriceFormat(invoiceInfo.withdrawnAmount) }}</span>
          </div>
          <div class="mt-2 d-flex justify-content-between">
            <span class="font-12">{{ $t('handling_fee') }}</span>
            <span class="font-bold font-15">{{ getPriceFormat(invoiceInfo.handlingFee) }}</span>
          </div>
          <div class="mt-2 d-flex justify-content-between" v-if="invoiceInfo.key === ''">
            <span class="font-12">{{ $t('total_remain_balance') }}</span>
            <span class="font-bold font-15">{{ getPriceFormat(invoiceInfo.chargedAmount - invoiceInfo.withdrawnAmount - invoiceInfo.spendAmount) }}</span>
          </div>
          <div class="w-100 mt-10" v-if="invoiceInfo.historyList.length > 0">
            <table class="w-100" border="1">
              <thead>
                <tr>
                  <th style="width: 17%;" class="p-1 font-10">{{ $t('username') }}</th>
                  <th style="width: 17%;" class="p-1 font-10">{{ $t('recharge_report') }}</th>
                  <th style="width: 15%;" class="p-1 font-10">{{ $t('amount') }}</th>
                  <th style="width: 17%;" class="p-1 font-10">{{ $t('handling_fee') }}</th>
                  <th style="width: 17%;" class="p-1 font-10">{{ $t('date') }}</th>
                  <th style="width: 17%;" class="p-1 font-10" v-if="invoiceInfo.key === ''">{{ $t('employee_name') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(historyInfo, index) in invoiceInfo.historyList" :key="(historyInfo, index)">
                  <td class="p-1 font-8">{{ historyInfo.userName }}</td>
                  <td class="p-1 font-8">{{ $t(historyInfo.type === TYPE_CHARGE ? 'charged' : 'withdrawn') }}</td>
                  <td class="p-1 font-8">{{ getPriceFormat(historyInfo.amount) }}</td>
                  <td class="p-1 font-8">{{ getPriceFormat(historyInfo.handlingFee) }}</td>
                  <td class="p-1 font-8">{{ getDateStringFromTimestamp(historyInfo.createdAt) }}</td>
                  <td class="p-1 font-8" v-if="invoiceInfo.key === ''">{{ historyInfo.employeeName || myInfo.userName }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </vue-html2pdf>
    </div>
  </div>
</template>

<style lang="scss">
  .tag-normal {
    padding: 10px 15px !important;
    border-radius: 10px !important;
    background-color: #F5F5F5 !important;
    color: #1F1F1F !important;
  }
  .tag-selected {
    padding: 10px 15px !important;
    border-radius: 10px !important;
    color: white !important;
    background-color: #A10559 !important;
  }
</style>

<script>
import VueHtml2pdf from 'vue-html2pdf';

import { firestore } from '../../../main';
import { onSnapshot, getDocs, query, collection, where } from 'firebase/firestore';
import { getDecimalFormat, getPriceFormat, getDateStringFromTimestamp, toFileName, getCurDateString, zeroPad, showLoading, isMobile } from '../../../functions';

import download from '@/assets/images/download.png';
import logo from '@/assets/images/logo_for_invoice.png';

export default {
  name: 'DrinkWallet',
  components: {
    VueHtml2pdf
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    isWide() {
      return this.$store.state.isWide;
    },
    myInfo() {
      return this.$store.state.myInfo;
    },
    myEventList() {
      return this.$store.state.myEventList;
    },
    employeeKeyList() {
      const list = [];
      list.push({
        key: this.$store.state.myId,
        name: this.myInfo ? this.myInfo.userName : ''
      });
      const employeeList = this.$store.state.employeeList.filter(element => element.inUse === true && element.role === 2 && element.useChargingSystem === true && element.eventId === this.$route.params.eventId);
      employeeList.sort((a, b) => (a.name > b.name) ? 1 : -1);
      employeeList.forEach(employeeInfo => {
        list.push({
          key: employeeInfo.name,
          name: employeeInfo.name
        });
      });
      return list;
    }
  },
  watch: {
    myEventList() {
      this.checkEvent();
    },
    selectedTag() {
      this.getDrinkWalletHistoryListTask();
    },
    employeeKeyList() {
      this.refreshData();
    }
  },
  data() {
    return {
      TYPE_CHARGE: 1,
		  TYPE_WITHDRAW: 2,
		  TYPE_BUY_DRINK: 3,
      assets: {
        download,
        logo
      },
      htmlToPdfOptions: {
        margin: 10,
        filename: 'Invoice',
        image: {
          type: 'jpeg',
          quality: 1.0
        },
        html2canvas: {
          scale: 5,
          useCORS: true
        }
      },
      tabIndex: 0,
      eventInfo: null,
      selectedTag: '',
      tagList: [],
      keywordTag: '',
      visibleSelectTagDialog: false,
      cacheUserList: [],
      userList: [],
      selectedUserId: '',
      items: null,
      invoiceInfo: null,
      historyList: null,
      snapHistoryList: null,
      loader: null
    };
  },
  mounted() {
    if (this.$route.params.eventId) {
      if (this.myInfo) {
        if (this.myInfo.userType === this.USER_ORGANIZER) {
          this.checkEvent();
        } else {
          this.$toast.error('No permission!!');
          this.$router.push('/');
        }
      } else {
        this.$toast.info(this.$t('alert_sign_in'));
        this.$router.push('/');
      }
    } else {
      this.$router.push('/');
    }
  },
  destroyed() {
    if (this.snapHistoryList) {
      this.snapHistoryList();
    }
  },
  methods: {
    getDecimalFormat,
    getPriceFormat,
    getDateStringFromTimestamp,
    zeroPad,
    checkEvent() {
      if (this.myEventList) {
        const needLoadData = this.eventInfo === null;
        const eventInfo = this.myEventList.find(element => element.eventId === this.$route.params.eventId);
        if (eventInfo) {
          if (eventInfo.userId !== this.$store.state.myId) {
            this.$toast.error('This is not your event!!');
            this.$router.push('/my_events/1');
          } else {
            if (eventInfo.tag && eventInfo.tagList && eventInfo.tagList.length !== this.tagList.length) {
              this.tagList = [];
              eventInfo.tagList.forEach(element => this.tagList.push(element));
              this.tagList.reverse();
              this.selectedTag = eventInfo.tag;
            }
            this.eventInfo = eventInfo;
            if (needLoadData && !this.selectedTag) {
              this.getDrinkWalletHistoryListTask();
            }
          }
        } else {
          this.$toast.error('Invalid event!');
          this.$router.push('/my_events/1');
        }
      }
    },
    generateInvoice(key) {
      this.invoiceInfo = this.items.find(element => element.key === key);
      if (this.invoiceInfo && this.eventInfo) {
        this.loader = showLoading(this);
        const tagIndex = this.getTagIndex();
        const tagName = tagIndex === -1 ? '' : `_${tagIndex}`;
        this.htmlToPdfOptions.filename = `${toFileName(this.eventInfo.name)}${tagName}_Charging_System_${getCurDateString()}`;
        this.$refs.html2Pdf.generatePdf();
      } else {
        this.$toast.error(this.$t('alert_not_valid_event'));
      }
    },
    getFilteredTagList() {
      return this.tagList.filter(element => element.toLowerCase().includes(this.keywordTag.toLowerCase()));
    },
    getTagIndex() {
      if (this.eventInfo.tagList && this.selectedTag) {
        return this.eventInfo.tagList.findIndex(element => element === this.selectedTag);
      }
      return -1;
    },
    closeSelectTagDialog(tag) {
      if (tag) {
        this.selectedTag = tag;
      }
      this.visibleSelectTagDialog = false;
    },
    onProgress(progress) {
      if (progress === 100 && this.loader) {
        this.loader.hide();
        this.loader = null;
      }
    },
    refreshData() {
      if (this.historyList) {
        const items = [];
        const totalUserIdList = [];
        const totalInfo = {
          key: '',
          name: this.$t('all'),
          expanded: false,
          chargedAmount: 0,
          withdrawnAmount: 0,
          spendAmount: 0,
          handlingFee: 0,
          userCount: 0,
          historyList: []
        };
        items.push(totalInfo);
        this.employeeKeyList.forEach(employeeInfo => {
          const item = {
            key: employeeInfo.key,
            name: employeeInfo.name,
            expanded: false,
            chargedAmount: 0,
            withdrawnAmount: 0,
            handlingFee: 0,
            spendAmount: 0,
            userCount: 0,
            historyList: []
          };
          const userIdList = [];
          this.historyList.filter(element => element.key === employeeInfo.key && element.tag === this.selectedTag).forEach(historyInfo => {
            if (!totalUserIdList.includes(historyInfo.userId)) {
              totalUserIdList.push(historyInfo.userId);
            }
            if (!userIdList.includes(historyInfo.userId)) {
              userIdList.push(historyInfo.userId);
            }
            if (historyInfo.type === this.TYPE_CHARGE) {
              totalInfo.chargedAmount += historyInfo.amount;
              totalInfo.handlingFee += historyInfo.handlingFee || 0;
              item.chargedAmount += historyInfo.amount;
              item.handlingFee += historyInfo.handlingFee || 0;
            } else if (historyInfo.type === this.TYPE_WITHDRAW) {
              totalInfo.withdrawnAmount += historyInfo.amount;
              totalInfo.handlingFee += historyInfo.handlingFee || 0;
              item.withdrawnAmount += historyInfo.amount;
              item.handlingFee += historyInfo.handlingFee || 0;
            } else if (historyInfo.type === this.TYPE_BUY_DRINK) {
              totalInfo.spendAmount += historyInfo.amount;
              item.spendAmount += historyInfo.amount;
            }
            const userInfo = this.cacheUserList.find(element => element.userId === historyInfo.userId);
            if (userInfo) {
              historyInfo['userName'] = userInfo.userName;
            } else {
              historyInfo['userName'] = '--';
            }
            if (historyInfo.type < this.TYPE_BUY_DRINK) {
              item.historyList.push(historyInfo);
              totalInfo.historyList.push(historyInfo);
            }
          });
          item.userCount = userIdList.length;
          item.historyList.sort((a, b) => (a.createdAt.seconds > b.createdAt.seconds) ? -1 : 1);
          items.push(item);
        });
        totalInfo.userCount = totalUserIdList.length;
        totalInfo.historyList.sort((a, b) => (a.createdAt.seconds > b.createdAt.seconds) ? -1 : 1);
        this.items = items;
      } else {
        this.items = null;
      }
    },
    getDrinkWalletHistoryListTask() {
      if (!this.eventInfo) {
        return;
      }
      if (this.snapHistoryList) {
        this.snapHistoryList();
      }
      let q;
      if (this.selectedTag) {
        q = query(collection(firestore, 'drinkWalletHistory'), where('eventId', '==', this.$route.params.eventId), where('tag', '==', this.selectedTag));
      } else {
        q = query(collection(firestore, 'drinkWalletHistory'), where('eventId', '==', this.$route.params.eventId));
      }
      const loader = showLoading(this);
      this.snapHistoryList = onSnapshot(q, querySnapshot => {
        const historyList = [];
        querySnapshot.forEach(doc => {
          const data = doc.data();
          if (data.employeeName) {
            data['key'] = data.employeeName;
          } else {
            data['key'] = this.$store.state.myId;
          }
          historyList.push(data);
        });
        this.historyList = historyList;
        this.refreshData();
        if (historyList.length > 0) {
          this.getUserListTask(historyList, loader)
        } else {
          loader.hide();
        }
      });
    },
    getUserListTask(historyList, loader) {
      const promises = [];
      var idList = [];
      historyList.forEach(info => {
        if (!this.cacheUserList.find(element => element.userId === info.userId) && !idList.includes(info.userId)) {
          idList.push(info.userId);
        }
        if (idList.length === 10) {
          promises.push(getDocs(query(collection(firestore, 'user'), where('userId', 'in', idList))));
          idList = [];
        }
      });
      if (idList.length > 0) {
        promises.push(getDocs(query(collection(firestore, 'user'), where('userId', 'in', idList))));
      }
      Promise.all(promises).then(snapshots => {
        loader.hide();
        const list = [];
        for (const snap of snapshots) {
          for (const doc of snap.docs) {
            list.push(doc.data());
          }
        }
        this.cacheUserList = this.cacheUserList.concat(list);
        this.refreshData();
      });
    }
  }
};
</script>